<template>
  <div ref="container">
    <b-alert show variant="danger" dismissible v-on:dismiss="$emit('dismiss')">
      <h4 class="alert-heading">Import Error!</h4>
      <SocietyCSVUploadRowErrors
        v-for="(error, index) in errors"
        :key="error.rowNumber + index"
        :messages="error.messages"
        :row-number="error.rowNumber"
      />
    </b-alert>
  </div>
</template>

<script>
import SocietyCSVUploadRowErrors from './SocietyCSVUploadRowErrors';
export default {
  name: 'SocietyCSVUploadErrors',
  components: {
    SocietyCSVUploadRowErrors,
  },
  props: {
    errors: [Array, Object],
  },
  watch: {
    errors: {
      immediate: true,
      handler: function (currVal) {
        if (currVal) {
          this.$nextTick(() => {
            if (this.$refs.container) {
              this.$refs.container.scrollIntoView();
            }
          });
        }
      },
    },
  },
};
</script>

<style scoped></style>
